import { cx } from '@linaria/core';
import { memo } from 'react';
import { locales } from '../../../locales/en';
import Button from '../../Buttons/Button';
import Progress from '../Progress';
import { junkStyles, refreshStyles, reload, rootStyles, verificationStyles } from './shared';
import "./SignupSuccess.linaria.module.css!=!./SignupSuccess?./SignupSuccess.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNT7aIN8wyK6vMKNRD5Van5eeV6BZnVqVaGRal5lrXcgEAnm/itjAAAAA="
type SignupSuccessProps = {
  email: string;
};
const emailStyles = "atm_c8_1j6vyhq";
const SignupSuccess = memo((props: SignupSuccessProps) => {
  const {
    email
  } = props;
  return <div className={rootStyles}>
            <h4 className={'typography gutter-bottom centered'}>
                {locales.signup.thankYouForSigningUp}
            </h4>
            <p className={cx('typography gutter-bottom', emailStyles)}>
                {locales.signup.sentEmail}
                <b>{email}</b>. {locales.signup.openEmailClickLink}
            </p>
            <div className={junkStyles}>{locales.signup.checkSpam}</div>
            <h6 className={'typography gutter-bottom centered'}>
                {locales.signup.awaitingVerification}
            </h6>
            <Progress />
            <div className={verificationStyles}>
                {locales.signup.ifVerifiedButMessagePersists}
            </div>
            <Button onClick={reload} size="medium" className={refreshStyles}>
                {locales.signup.refresh}
            </Button>
        </div>;
});
export default SignupSuccess;